import { StyledPagination } from '../../Molecules/Pagination/styles'
import { StyledReview } from '../../Molecules/Review/styles'
import { styled } from '../../Styles/stitches.config'

export const ReviewsContainer = styled('div', {
    display: 'grid',

    '@mobile': {
        gridTemplateColumns: '1fr',
        my: '-$3',
    },

    '@desktop': {
        mx: '-$3',
    },

    [`& > ${StyledReview}`]: {
        '@mobile': {
            py: '$3',

            '&:not(:last-of-type)': {
                borderBottom: '1px solid $neutral300',
            },
        },

        '@desktop': {
            px: '$3',

            '&:not(:last-of-type)': {
                borderRight: '1px solid $neutral300',
            },
        },
    },
})

export const StyledReviews = styled('div', {
    display: 'grid',
    gap: '$3',

    [`& ${StyledPagination}`]: {
        justifySelf: 'center',
    },
})
